import styled from '@emotion/styled';
import { ChatTextboxViewProps } from './types';
import { Button, colors, Input, MagicStars } from '@innovationdepartment/proxima-ui';
import UploadIcon from './UploadIcon';
import FormatTooltip from './ChatTextbox.FormatTooltip';
import ConnectedIntegrations from './ChatTextbox.ConnectedIntegrations.Container';

const ChatTextboxWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0 32px;
  margin-bottom: 100px;
`;

const ChatTextboxContainer = styled.div<{ disabled?: boolean }>`
  width: 100%;
  max-width: 774px;
  margin-top: 60px;
  border-radius: 8px;
  padding: 4px;
  border: 1px solid ${({ disabled }) => (disabled ? colors.neutral20 : colors.neutral100)};
  background-color: ${({ disabled }) => (disabled ? colors.neutral0 : colors.white)};
`;

const InputWrapper = styled.div<{ disabled?: boolean }>`
  & [class*='MuiInputAdornment'] {
    margin-right: 8px;
    & svg * {
      fill: ${({ disabled }) => (disabled ? colors.neutral50 : colors.neutral40)};
    }
  }

  & fieldset {
    border: none;
  }

  & input {
    &.MuiInputBase-input.MuiInputBase-input::placeholder {
    ${({ disabled }) => {
      if (disabled) return `text-fill-color: ${colors.neutral50};`;

      return `color: ${colors.neutral40};`;
    }}
    margin-bottom: 0;
  }
`;

const SubElementsWrapper = styled.div`
  gap: 8px;
  flex: 1;
  display: flex;
  justify-content: flex-start;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const BottomSectionWrapper = styled.div`
  margin-top: 8px;
  display: flex;
  justify-content: space-between;
`;

const ChatTextboxView = (props: ChatTextboxViewProps) => {
  const { disabled, onKeyPress, onChange, onSend, value, inputKey } = props;

  return (
    <ChatTextboxWrapper>
      <ChatTextboxContainer disabled={disabled}>
        <InputWrapper disabled={disabled}>
          <Input
            key={inputKey}
            fullWidth
            value={value}
            disabled={disabled}
            onChange={onChange}
            placeholder="Start typing..."
            startAdornment={<MagicStars />}
            onKeyPress={onKeyPress}
          />
        </InputWrapper>
        <BottomSectionWrapper>
          <SubElementsWrapper>
            <FormatTooltip />
            <ConnectedIntegrations />
          </SubElementsWrapper>
          <ButtonWrapper>
            <Button onClick={onSend} label="" size="medium" disabled={disabled || !value}>
              <UploadIcon />
            </Button>
          </ButtonWrapper>
        </BottomSectionWrapper>
      </ChatTextboxContainer>
    </ChatTextboxWrapper>
  );
};

export default ChatTextboxView;
